<template>
  <Layout>
    <div style="width:100%">
      <q-table
        v-if="!loading && companies.length > 1"
        hide-bottom
        title="Total of All Companies Fleet's Current Valuation"
        :rows-per-page-options="[0]"
        square
        :data="companies"
        :columns="columns"
        row-key="name"
      >
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-bold text-black"
              auto-width
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>

        <template v-slot:body="props">
          <q-tr @click="props.expand = !props.expand" :props="props">
            <q-td auto-width>
              <span>
                <i
                  style="font-size:12px"
                  :class="
                    props.expand ? 'fas fa-chevron-up' : 'fas fa-chevron-down'
                  "
                  v-if="props.key !== 'Total' && props.row.locations.length > 0"
                ></i>
                {{ props.key }}</span
              >
            </q-td>
            <q-td auto-width>
              {{ props.row.total.count }}
            </q-td>
            <q-td auto-width>
              {{ dollars(props.row.total.auction) }}
            </q-td>
            <q-td auto-width>
              {{ dollars(props.row.total.payoff) }}
            </q-td>
            <q-td auto-width>
              {{ dollars(props.row.total.revenue) }}
            </q-td>
          </q-tr>
          <transition-group
            name="component-fade"
            v-for="location in props.row.locations"
            :key="location.id"
            :props="props"
            class="q-tr"
            :class="{ 'active-list': props.expand }"
            tag="tr"
          >
            <q-td v-show="props.expand" auto-width :key="location.name">
              {{ location.name }}
            </q-td>
            <q-td auto-width :key="location.count" v-show="props.expand">
              {{ location.count }}
            </q-td>
            <q-td auto-width :key="location.auction" v-show="props.expand">
              {{ dollars(location.auction) }}
            </q-td>
            <q-td auto-width :key="location.payoff" v-show="props.expand">
              {{ dollars(location.payoff) }}
            </q-td>
            <q-td auto-width :key="location.revenue" v-show="props.expand">
              {{ dollars(location.revenue) }}
            </q-td>
          </transition-group>
        </template>
      </q-table>
      <div class="loading-infinite" v-if="loading">
        <div>
          <q-spinner-facebook color="primary" size="40px" />
          <div class="text-grey-7">Loading</div>
        </div>
      </div>
      <q-card
        square
        v-if="!loading && companies.length === 1"
        style="padding:15px"
      >
        <empty-value
          name="company"
          description="If you want to see summary of current values,please add company"
        ></empty-value>
      </q-card>
    </div>
  </Layout>
</template>

<script>
import Layout from "../components/Layout";
import EmptyValue from "../components/EmptyValue";
import axios from "../axios";
import {defaultStatusValues} from "@/enums";
export default {
  metaInfo() {
    return {
      title: "Management summary report of total fleet’s current values. | FMS",
      meta: [
        {
          name: "description",
          content: "Management summary report of total fleet’s current values.",
        },
        {
          property: "og:title",
          content:
            "Management summary report of total fleet’s current values. | FMS",
        },
        { property: "og:site_name", content: "FMS" },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
  data() {
    return {
      loading: false,
      companies: [],
      columns: [
        {
          name: "_a",
          field: "_a",
          label: "",
        },
        {
          name: "count",
          field: "count",
          label: "Fleet Size",
        },
        {
          label: "Auction Value",
          name: "auction",
          field: "auction",
        },
        {
          label: "Estimated Payoff",
          name: "payoff",
          field: "payoff",
        },
        {
          label: "Estimated Revenue/Loss",
          name: "revenue",
          field: "revenue",
        },
      ],
    };
  },
  async mounted() {
    this.loading = true;
    const { data } = await axios.post("vehicle-analysis/internal-list-summary-for-sale", {}, {
      params: {
        statuses: defaultStatusValues
      },
    });
    this.loading = false;
    const { companies, total } = data.data;
    this.companies = companies;
    this.companies = [...this.companies, { name: "Total", total }];
  },
  components: {
    Layout,
    EmptyValue,
  },
  computed: {
    dollars() {
      return (val) =>
        val
          ? val.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })
          : 0;
    },
  },
};
</script>

<style lang="scss">
th {
  text-align: center !important;
}
td {
  text-align: center !important;
  cursor: pointer;
}
.active-list {
  background: #f5f5f5;
}
</style>
